import styled from 'styled-components';
import { StyleColor, navBarButtonWrapperStyle, navBarIconStyle } from '../../../utils/styles-constants';

export const StyledTheaterFooter = styled('div')`
	background: ${StyleColor.Grey800};
	color: ${StyleColor.White};
	width: 100%;
	min-height: 60px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	font-size: 14px;
	padding: 15px 10px 15px 25px;
	box-sizing: border-box;
	fill: ${StyleColor.Grey600};
`;

export const Extension = styled('div')`
	background-color: rgba(0,0,0,.5);
	border-radius: 2px;
	border: 1px solid rgba(255,255,255,.5);
	color: ${StyleColor.White};
	font-size: 12px;
	text-transform: uppercase;
	padding: 4px 8px;
	margin-right: 15px;
`;

export const Label = styled('div')`
	flex-grow: 1;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const ActionIcons = styled('div')`
	display: flex;
	justify-content: flex-end;
	min-width: 160px;

	> * {
		${navBarButtonWrapperStyle};
	}

	svg {
		${navBarIconStyle}
		fill: ${StyleColor.Grey600};
	}
`;

export const DownloadButton = styled('button')`
	border: 0;
	outline: 0;
	background-color: transparent;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Footer/styles.ts